export default class FeedbackModalController {

    private openPopupMethod: () => void;

    private closePopupMethod: () => void;

    public set openMethod(method: (...d: any) => void) {
        this.openPopupMethod = method;
    }

    public set closeMethod(method: (...d: any) => void) {
        this.closePopupMethod = method;
    }

    public open = () => {
        if (this.openPopupMethod) {
            this.openPopupMethod();
        }
    }

    public close = () => {
        if (this.closePopupMethod) {
            this.closePopupMethod();
        }
    }

    public dispose = () => {
        this.openPopupMethod = null;
        this.closePopupMethod = null;
    }
}
